import { round } from 'lodash';

import { BATWING_ANGLE, BATWING_ISOSCELES_SIDE_FACTOR } from '~/core/constants';

/**
 * Calculates the equal sides of an isosceles triangle given its vertex angle and hypotenuse
 * @param angle - The vertex angle of the isosceles triangle
 * @param hypotenuse - The length of the hypotenuse
 * @returns The length of the equal sides rounded to 2 decimal places, or 0 if inputs are invalid
 *
 * @note
 * This application only handles right isosceles triangles or isosceles triangles
 * with batwing angles (135°).
 * The result is rounded to 2 decimal places for consistency with other measurements in the app.
 */
export const calculateIsoscelesTriangleSide = (
  angle: number,
  hypotenuse: number
): number => {
  if (Number.isNaN(angle) || Number.isNaN(hypotenuse)) {
    return 0;
  }
  const isBatwingAngle = angle % BATWING_ANGLE === 0;

  const triangleSideLength = isBatwingAngle
    ? hypotenuse * BATWING_ISOSCELES_SIDE_FACTOR
    : hypotenuse / Math.sqrt(2);

  return round(triangleSideLength, 2);
};
